import React from 'react';
import './CakeCard.css';
import { Link } from 'react-router-dom';

export default function CakeCard({ cake, addToCart }) {
    const hasPoundPricing = cake.pricePerPound && Array.isArray(cake.poundSizes) && cake.poundSizes.length > 0;
    const defaultFromPound = hasPoundPricing ? Number(cake.pricePerPound) * Math.min(...cake.poundSizes) : 0;
    const displayPrice = (cake.price && Number(cake.price) > 0) ? Number(cake.price) : defaultFromPound;

    return (
        <Link to={`/cake/${cake.id}`}>
            <div className="cake-card">
                <div className="cake-img-wrap">
                    <img src={cake.image} alt={cake.name} className="cake-img" />
                    {cake.badge && <span className="cake-badge">{cake.badge}</span>}

                    <div className="cake-logo-mark">
                        <span>P</span>
                    </div>
                </div>
                <div className="cake-info">
                    <p className="cake-category">{cake.category}</p>
                    <h3 className="cake-name">{cake.name}</h3>
                    <div className="cake-rule" />
                    <p className="cake-desc">{cake.description}</p>
                    <div className="cake-footer">
                        <span className="cake-price">PKR {displayPrice.toLocaleString()}</span>
                        <button className="cake-add-btn" onClick={() => addToCart(cake)}>
                            Add to Order
                        </button>
                    </div>
                </div>
            </div>
        </Link>
    );
}